import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SnowAnimationComponent } from './snow-animation.component';

@NgModule({
  declarations: [SnowAnimationComponent],
  exports: [SnowAnimationComponent],
  imports: [CommonModule],
})
export class SnowAnimationModule {}

